import { render, staticRenderFns } from "./GCCClue.vue?vue&type=template&id=19873d1f&"
import script from "./GCCClue.vue?vue&type=script&lang=js&"
export * from "./GCCClue.vue?vue&type=script&lang=js&"
import style0 from "./GCCClue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports